import React, { useEffect } from 'react';
import { Menu, Typography, Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadFilterProfiles } from '../../../../redux/actions/filters';
import { TitleAction } from '../../shared-components/TitleAction';
import Icon, { UserOutlined, PlusOutlined } from '@ant-design/icons';
import { ReactComponent as shared_icon } from '../../../../assets/icons/SharedIcon.svg';
import { ReactComponent as public_icon } from '../../../../assets/icons/public.svg';
import { changeTitle } from '../../../../redux/actions/app';
import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';
import { STATUS } from '../../../../redux/constants';
import cx from 'classnames';
import { resetSelectedFilterProfile } from '../../../../redux/actions/filters';

export function FilterProfileSubMenu(props) {
  const scopeIconMapping = {
    USER: <UserOutlined />,
    ORGANISATION: <Icon component={shared_icon} />,
    GLOBAL: <Icon component={public_icon} />,
  };
  const dispatch = useDispatch();
  const filterProfiles = useSelector((state) => state?.filter?.profiles);
  const { Text } = Typography;
  const {
    isKeyOn,
    setSessionStorage,
    toggleKey,
    advancedFilterMenuOpen,
    ...rest
  } = props;

  function returnBlankFilterProfile() {
    const blankExpression = [
      {
        id: Math.random(),
        conditions: [
          { ref: React.createRef(), id: Math.random(), position: 1 },
        ],
        position: 1,
      },
    ];
    const newProfile = {
      condition_blocks: blankExpression,
      is_mine: true,
      name: '',
      scope: 'USER',
      send_alert: true,
      send_notification: false,
      tags: [],
    };

    return newProfile;
  }

  useEffect(() => {
    if (
      props.mySubscriptionPlanStatus === STATUS.LOADED &&
      props.mySubscriptionPlan &&
      props.mySubscriptionPlan?.has_access_to_threat_ranking
    ) {
      if (filterProfiles?.length <= 0) {
        dispatch(loadFilterProfiles());
      }
    }
  }, []);

  useEffect(() => {
    if (
      props.mySubscriptionPlanStatus === STATUS.LOADED &&
      props.mySubscriptionPlan &&
      props.mySubscriptionPlan?.has_access_to_threat_ranking
    ) {
      if (filterProfiles?.length <= 0) {
        dispatch(loadFilterProfiles());
      }
    }
  }, [props.mySubscriptionPlanStatus]);

  return props?.mySubscriptionPlan?.has_access_to_advanced_filter ? (
    <Menu.SubMenu
      data-cy={`leftMenuSidebarFilterProfiles`}
      className={cx(styles.first_level_submenu, styles.exceptionBackground)}
      title={
        <TitleAction
          menuKey={'filter-profiles'}
          showDownArrow={props.isKeyOn('filter-profiles')}
          titleAction={() => props.toggleKey('filter-profiles')}
          title={
            <Text className={styles.additional_indentation} strong>
              Filter Profiles
            </Text>
          }
        />
      }
      onTitleClick={() => props.toggleKey('filter-profiles')}
      {...rest}
    >
      <Menu.Item
        onClick={() => {
          props.setSessionStorage('create-new-filter-profile-menu-item');
          props.openCreateNewAdvancedFilter();
          dispatch(resetSelectedFilterProfile(returnBlankFilterProfile()));
        }}
        key={'create-new-filter-profile-menu-item'}
        disabled={!props?.mySubscriptionPlan?.has_access_to_threat_ranking}
        data-cy={`leftMenuSidebarCreateNewFilterProfile`}
      >
        <Tooltip
          title={
            props?.mySubscriptionPlan?.has_access_to_threat_ranking ? (
              'Create New Filter Profile'
            ) : (
              <>
                Advanced Filter Profiles are not part of this subscription plan.
                To upgrade your subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            )
          }
          placement={'right'}
        >
          <Link
            to={`/?openAdvancedFilter=true?openCreateNewAdvancedFilter=true?fromMenu=true`}
          >
            <Button
              className={cx(styles.add_new_button, {
                [styles.advMenuOpen]: advancedFilterMenuOpen,
              })}
              type="link"
            >
              Create New <PlusOutlined />
            </Button>
          </Link>
        </Tooltip>
      </Menu.Item>

      {filterProfiles &&
        filterProfiles.map((fp, idx) => {
          return (
            <Menu.Item
              onClick={() => {
                dispatch(changeTitle('Threat Ranking', null));
                document.title = `${fp.name} - Silent Push`;
                props.setSessionStorage(fp.uuid);
                props.openEditAdvancedFilter();
              }}
              key={fp.uuid}
              disabled={
                !props?.mySubscriptionPlan?.has_access_to_threat_ranking
              }
              data-cy={`leftMenuSidebarFilterProfile-${fp.name}`}
            >
              <TitleAction
                menuKey={fp.uuid}
                title={
                  <Tooltip
                    placement="right"
                    title={fp?.name?.length > 20 ? fp?.name : ''}
                  >
                    <div className={styles.secondary_section_title}>
                      <Link
                        to={`/?filterProfile=${fp.uuid}?openAdvancedFilter=true`}
                        className={styles.additional_indentation}
                      >
                        <span style={{ marginRight: '4px' }}>
                          {scopeIconMapping[fp.scope]}
                        </span>
                        <span>
                          {fp?.name?.length > 20
                            ? fp?.name?.substr(0, 20) + '...'
                            : fp?.name}
                        </span>
                      </Link>
                    </div>
                  </Tooltip>
                }
              />
            </Menu.Item>
          );
        })}
    </Menu.SubMenu>
  ) : (
    props.returnSubstituteMenu({
      type: 'menuItem',
      tooltipMessage: (
        <>
          Filter profiles is not part of this subscription plan. To upgrade your
          subscription contact us at{' '}
          <a target="_blank" href="mailto:sales@silentpush.com">
            sales@silentpush.com
          </a>
          .
        </>
      ),
      menuTitle: 'Filter Profiles',
      icon: null,
    })
  );
}
